export function OutlineFileOkIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0179 20.9993C17.7802 20.9993 20.0195 18.76 20.0195 15.9977C20.0195 13.2354 17.7802 10.9961 15.0179 10.9961C12.2556 10.9961 10.0164 13.2354 10.0164 15.9977C10.0164 18.76 12.2556 20.9993 15.0179 20.9993Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7954 16.5543L14.197 17.8839C14.9842 17.0967 17.2402 14.8887 17.2402 14.8887"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.01945 20.9999H5.98426C4.88026 20.9999 3.98267 20.1023 3.98267 18.9983V4.99679C3.98267 3.8928 4.88026 3 5.98426 3H12.2194C12.7522 3 13.261 3.2112 13.6354 3.5856L17.4658 7.41118C17.6386 7.58398 17.773 7.78558 17.869 8.00158"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
